import { HtmlElementProps } from "../../../types/globals";
import {
	DisplayProps,
	FlexboxProps,
	LayoutProps,
	PositionProps,
} from "styled-system";
import { isSpaceOption, SpaceOptions } from "../../../types/theming";

export type SpaceOptionsOrZero = SpaceOptions | "0";

/**
 * Type Guard. Call to determine if value is a SpaceOptionsOrZero option.
 * @param value The value to check.
 * @returns Boolean true if value is an option, otherwise false.
 */
export function IsSpaceOptionOrZero(value: any): value is SpaceOptionsOrZero {
	return isSpaceOption(value) || value === "0";
}

export type Space =
	| SpaceOptionsOrZero
	| `${SpaceOptionsOrZero} ${SpaceOptionsOrZero}`
	| `${SpaceOptionsOrZero} ${SpaceOptionsOrZero} ${SpaceOptionsOrZero}`
	| `${SpaceOptionsOrZero} ${SpaceOptionsOrZero} ${SpaceOptionsOrZero} ${SpaceOptionsOrZero}`;

export type Gap =
	| SpaceOptionsOrZero
	| `${SpaceOptionsOrZero} ${SpaceOptionsOrZero}`;

export type SpaceConditionalProps =
	| {
			/**
			 * Optionally set to change any default margin applied to a container.
			 */
			margin?: SpaceOptionsOrZero;
			marginY?: never;
			marginX?: never;
			marginTop?: never;
			marginRight?: never;
			marginBottom?: never;
			marginLeft?: never;

			/**
			 * Optionally set to change any default margin applied to a container.
			 */
			padding?: SpaceOptionsOrZero;
			paddingY?: never;
			paddingX?: never;
			paddingTop?: never;
			paddingRight?: never;
			paddingBottom?: never;
			paddingLeft?: never;
	  }
	| {
			margin?: never;

			/**
			 *
			 */
			marginY?: SpaceOptionsOrZero;

			/**
			 *
			 */
			marginX?: SpaceOptionsOrZero;

			marginTop?: never;
			marginRight?: never;
			marginBottom?: never;
			marginLeft?: never;

			padding?: never;

			/**
			 *
			 */
			paddingY?: SpaceOptionsOrZero;

			/**
			 *
			 */
			paddingX?: SpaceOptionsOrZero;

			paddingTop?: never;
			paddingRight?: never;
			paddingBottom?: never;
			paddingLeft?: never;
	  }
	| {
			margin?: never;
			marginY?: never;
			marginX?: never;

			/**
			 *
			 */
			marginTop?: SpaceOptionsOrZero;

			/**
			 *
			 */
			marginRight?: SpaceOptionsOrZero;

			/**
			 *
			 */
			marginBottom?: SpaceOptionsOrZero;

			/**
			 *
			 */
			marginLeft?: SpaceOptionsOrZero;

			padding?: never;
			paddingY?: never;
			paddingX?: never;

			/**
			 *
			 */
			paddingTop?: SpaceOptionsOrZero;

			/**
			 *
			 */
			paddingRight?: SpaceOptionsOrZero;

			/**
			 *
			 */
			paddingBottom?: SpaceOptionsOrZero;

			/**
			 *
			 */
			paddingLeft?: SpaceOptionsOrZero;
	  };

export type SpaceProps = Omit<HtmlElementProps, "color"> &
	//SpaceConditionalProps &
	DisplayProps &
	FlexboxProps &
	LayoutProps &
	PositionProps & {
		/*
      TODO:
      We want to apply conditional props to margin and padding, but it presented problems with
      certain components. A ticket has been created to try and resolve this. Ticket no: 
    */
		margin?: SpaceOptionsOrZero;
		marginY?: SpaceOptionsOrZero;
		marginX?: SpaceOptionsOrZero;
		marginTop?: SpaceOptionsOrZero;
		marginRight?: SpaceOptionsOrZero;
		marginBottom?: SpaceOptionsOrZero;
		marginLeft?: SpaceOptionsOrZero;

		padding?: SpaceOptionsOrZero;
		paddingY?: SpaceOptionsOrZero;
		paddingX?: SpaceOptionsOrZero;
		paddingTop?: SpaceOptionsOrZero;
		paddingRight?: SpaceOptionsOrZero;
		paddingBottom?: SpaceOptionsOrZero;
		paddingLeft?: SpaceOptionsOrZero;

		/**
		 * Optionally set to change any default gap applied to a container.
		 */
		gap?: Gap;
	};
